/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Booster_Banner_TitleInputs */

const en_booster_banner_title = /** @type {(inputs: Booster_Banner_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Boosting packs are here!`)
};

const ar_booster_banner_title = /** @type {(inputs: Booster_Banner_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`حزم التعزيز متوفرة الآن!`)
};

const de_booster_banner_title = /** @type {(inputs: Booster_Banner_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Boost-Pakete sind da!`)
};

const es_booster_banner_title = /** @type {(inputs: Booster_Banner_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Los packs de boost ya están aquí!`)
};

const fr_booster_banner_title = /** @type {(inputs: Booster_Banner_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les packs de boost sont arrivés !`)
};

const it_booster_banner_title = /** @type {(inputs: Booster_Banner_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I pacchetti boost sono qui!`)
};

const ja_booster_banner_title = /** @type {(inputs: Booster_Banner_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ブーストパックが登場！`)
};

const ko_booster_banner_title = /** @type {(inputs: Booster_Banner_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`부스트 패키지 출시!`)
};

const pt_br_booster_banner_title = /** @type {(inputs: Booster_Banner_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Os pacotes de boost chegaram!`)
};

const ru_booster_banner_title = /** @type {(inputs: Booster_Banner_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Буст-пакеты уже здесь!`)
};

const th_booster_banner_title = /** @type {(inputs: Booster_Banner_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`แพ็คบูสต์มาแล้ว!`)
};

const tr_booster_banner_title = /** @type {(inputs: Booster_Banner_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Takviye paketleri geldi!`)
};

const zh_cn_booster_banner_title = /** @type {(inputs: Booster_Banner_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`加速礼包开卖中`)
};

const zh_tw_booster_banner_title = /** @type {(inputs: Booster_Banner_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`加速禮包開賣中`)
};

/**
* | output |
* | --- |
* | "Boosting packs are here!" |
*
* @param {Booster_Banner_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const booster_banner_title = /** @type {((inputs?: Booster_Banner_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Booster_Banner_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_booster_banner_title(inputs)
	if (locale === "ar") return ar_booster_banner_title(inputs)
	if (locale === "de") return de_booster_banner_title(inputs)
	if (locale === "es") return es_booster_banner_title(inputs)
	if (locale === "fr") return fr_booster_banner_title(inputs)
	if (locale === "it") return it_booster_banner_title(inputs)
	if (locale === "ja") return ja_booster_banner_title(inputs)
	if (locale === "ko") return ko_booster_banner_title(inputs)
	if (locale === "pt_br") return pt_br_booster_banner_title(inputs)
	if (locale === "ru") return ru_booster_banner_title(inputs)
	if (locale === "th") return th_booster_banner_title(inputs)
	if (locale === "tr") return tr_booster_banner_title(inputs)
	if (locale === "zh_cn") return zh_cn_booster_banner_title(inputs)
	return zh_tw_booster_banner_title(inputs)
});